<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Galerie photos " />
            <MediathequePoste />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import MediathequePoste from '../MediathequePoste/MediathequePoste'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'MediathequePostePage',
    components: {
        NavBar,
        PageTitle,
        MediathequePoste,
        FooterComp,
    }
}
</script>